<template>
  <div class="guide-wrap" v-show="guideShow">
    <div class="download">
      <img src="../../assets/panbrain.png" />
      <!-- <p class="name">般意 PanBrain</p> -->
    </div>
    <div class="browser">
      <p>
        1.请点击右上角按钮
        <br />
        2.选择【在浏览器中打开】
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guideShow: false,
      userAgent: navigator.userAgent,
    };
  },
  created() {
    if (this.isWeChatOrQQ(this.userAgent)) {
      this.guideShow = true;
      if (this.isIOS(this.userAgent)) {
        this.guideShow = false;
        window.location = "https://itunes.apple.com/cn/app/id1668551738";
        // window.location = 'https://testflight.apple.com/join/YBiWYgXv'
      }
    }
    // else if (this.userAgent.match(/(vivo|VIVO);?/i)) {
    //   window.location.href = "vivomarket://details?id=com.general_meaning"
    // }
    // else if (this.userAgent.match(/(OPPO|oppo);?/i)) {
    //   window.location.href = "oppomarket://details?packagename=com.general_meaning"
    // } else if (this.userAgent.match(/(HUAWEI|HONOR);?/i)) {
    //   window.location.href = "appmarket://details?id=com.general_meaning"
    // } else if (this.userAgent.match(/(XIAOMI|REDMI);?/i)) {
    //   window.location.href = "mimarket://details?id=com.general_meaning"
    // }
    else if (this.isAndroid(this.userAgent) || this.isHuaWei(this.userAgent)) {
      this.$router.push("/pack");
    } else if (this.isIOS(this.userAgent)) {
      (async () => {
        try {
          const { data } = await (
            await fetch("https://tools.panbrain.net/ip-check")
          ).json();
          console.log("region", data);
          const { country } = data;
          const isChineseRegion = ["CN", "HK", "MO", "TW"].includes(country);
          if (isChineseRegion) {
            // 跳转至"般意"
            window.location.href = "https://apps.apple.com/app/id1668551738";
          } else {
            // 跳转至"PanBrain"
            window.location.href = "https://apps.apple.com/app/id6738811478";
          }
        } catch (e) {
          // 跳转至"般意"
          window.location.href = "https://apps.apple.com/app/id1668551738";
        }
      })();
      // window.location = 'https://testflight.apple.com/join/YBiWYgXv'
    } else {
      // document.write('userAgent: \t', this.userAgent)
      this.$router.push("/pack");
    }
  },
  methods: {
    isIOS() {
      return !!this.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    isAndroid() {
      return (
        this.userAgent.indexOf("Android") > -1 ||
        this.userAgent.indexOf("Linux") > -1
      );
    },
    isHuaWei() {
      return !!(this.userAgent.indexOf("windows nt") > -1);
    },
    isWeChatOrQQ() {
      const ua = this.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        return true;
      } else if (/mqqbrowser[\S|\s]*qq/.test(ua) || / qq/.test(ua)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.download img {
  width: 26.9vw;
  height: 26.9vw;
}

.name {
  color: #888ef9;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 8vw;
  white-space: nowrap;
  margin-top: 2vw;
}

.browser {
  width: 100vw;
  height: 100vw;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  /* display: none; */
  color: #ffffff;
}

.browser p {
  margin-top: 5vw;
  margin-left: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Download.vue